export default __webpack_public_path__ + "static/media/GetGrowCart_Logo_Light.843dcb7a.jpg";